// extracted by mini-css-extract-plugin
module.exports = {"backButton":"styles_backButton__27gyo","chevron":"styles_chevron__19c_V"};